import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, unref as _unref, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d72c04"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gantt-wrap" }
const _hoisted_2 = { class: "gantt-toolbar" }
const _hoisted_3 = {
  key: 0,
  class: "gantt-project-info"
}
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"gantt-legend\" data-v-74d72c04><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#909399;\" data-v-74d72c04></i>未启动</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#409EFF;\" data-v-74d72c04></i>进行中</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#fab6b6;\" data-v-74d72c04></i>逾期进行中</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#E6A23C;\" data-v-74d72c04></i>正常待审核</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#f56c6c;\" data-v-74d72c04></i>逾期待审核</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#67C23A;\" data-v-74d72c04></i>完成</span><span class=\"legend-item\" data-v-74d72c04><i class=\"dot\" style=\"background:#c0c0c0;border:1px dashed #999;\" data-v-74d72c04></i>关闭(不显示)</span></div>", 1)
const _hoisted_5 = { class: "gantt-scale" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "scale-label" }, "时间刻度：", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("按天")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("按周")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("按月")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("指定天数")
const _hoisted_11 = {
  key: 1,
  class: "scale-label"
}
const _hoisted_12 = { class: "gantt-actions" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("显示全部任务")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("全部展开")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("全部折叠")
const _hoisted_16 = { class: "gantt-body" }
const _hoisted_17 = {
  key: 0,
  class: "gantt-loading-mask"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "加载中...", -1))
const _hoisted_19 = {
  key: 1,
  class: "gantt-empty"
}
const _hoisted_20 = {
  key: 2,
  class: "gantt-scroll"
}
const _hoisted_21 = { class: "gantt-row gantt-header-row" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gantt-title-cell" }, "任务标题", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gantt-info-cell" }, "执行人", -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "gantt-info-cell" }, "审核人", -1))
const _hoisted_25 = {
  key: 0,
  class: "gantt-info-cell gantt-info-cell-time"
}
const _hoisted_26 = ["onClick"]
const _hoisted_27 = ["onClick"]
const _hoisted_28 = { class: "toggle-icon-placeholder" }
const _hoisted_29 = ["onClick"]
const _hoisted_30 = ["title"]
const _hoisted_31 = ["title"]
const _hoisted_32 = {
  key: 1,
  class: "overdue-badge",
  title: "该任务下存在逾期环节"
}
const _hoisted_33 = ["title"]
const _hoisted_34 = ["title"]
const _hoisted_35 = ["title"]
const _hoisted_36 = { class: "gantt-row gantt-header-row" }
const _hoisted_37 = {
  key: 0,
  class: "date-month"
}
const _hoisted_38 = { class: "date-day" }
const _hoisted_39 = ["onClick"]
const _hoisted_40 = ["title"]
const _hoisted_41 = { class: "bar-percent" }
const _hoisted_42 = ["title"]
const _hoisted_43 = ["title"]

import { ref, computed, onMounted, onBeforeUnmount, nextTick } from 'vue';
	import { ElMessage } from 'element-plus';
	import { Loading } from '@element-plus/icons-vue';
	import { requestTaskGanttList, xmDetails2 } from '@/api/xmApi';

	
export default /*#__PURE__*/_defineComponent({
  name: 'GanttChart',
  props: {
		projectid: {
			type: [Number, String],
			default: 0
		},
		// 外部传入的任务数组（如跨项目查询结果的全部任务）。传入后不再请求后端、不加载项目信息
		tasks: {
			type: Array,
			default: null
		},
		// 任务未设置时间时的提示文案（表单环节场景为"未设置完成时间节点"）
		noDateText: {
			type: String,
			default: '未设置开始/结束时间'
		},
		// 是否在"审核人"右侧显示"完成时间"列（表单环节场景需要）
		showFinishTime: {
			type: Boolean,
			default: false
		}
	},
  emits: ['opentask'],
  setup(__props, { expose, emit }) {

const props = __props

	
	

	// 组件卸载标记，避免异步请求在卸载后回调操作已销毁实例
	let alive = true;
	onBeforeUnmount(() => {
		// 注意：不要在卸载钩子里修改响应式状态（如 loading），
		// 会触发一次渲染任务与卸载流程竞态，导致 Vue 内部卸载报错
		alive = false;
	});

	const loading = ref(false);
	const rawTasks = ref<any[]>([]);
	const ganttRightRef = ref<HTMLElement | null>(null);
	const projectInfo = ref<any>(null);

	// 外部传入任务时，将其标准化为甘特图可直接使用的扁平结构（兼容 {cell:{...}} 与 直接对象）
	// 注意：过滤掉 null/undefined 项，避免后续展开/取属性时报空指针
	const externalTasks = computed(() => {
		if (!props.tasks) return null;
		return props.tasks
			.filter((t: any) => t != null)
			.map((t: any) => {
				const src = t.cell ? t.cell : t;
				return { ...src, id: src.id };
			});
	});

	// 时间刻度模式：day=按天 week=按周 month=按月 custom=指定天数
	const scaleMode = ref<'day' | 'week' | 'month' | 'custom'>('day');
	const customDays = ref<number>(7); // 指定天数模式下的每列天数
	const dayWidth = ref(40); // 每刻度单元宽度 px

	// 切换刻度时调整列宽
	const onScaleChange = () => {
		if (scaleMode.value === 'day') dayWidth.value = 40;
		else if (scaleMode.value === 'week') dayWidth.value = 80;
		else if (scaleMode.value === 'month') dayWidth.value = 120;
		else if (scaleMode.value === 'custom') {
			// 指定天数模式下，天数越多列越宽
			dayWidth.value = Math.max(60, Math.min(200, customDays.value * 12));
		}
		// 滚动到今天
		nextTick(() => {
			scrollToToday();
		});
	};

	// 今天日期字符串 YYYY-MM-DD
	const todayStr = computed(() => {
		const d = new Date();
		const y = d.getFullYear();
		const m = String(d.getMonth() + 1).padStart(2, '0');
		const day = String(d.getDate()).padStart(2, '0');
		return `${y}-${m}-${day}`;
	});

	// 解析日期字符串为 Date（兼容 "YYYY-MM-DD" / "YYYY-MM-DD HH:mm:ss"）
	const parseDate = (s: string): Date | null => {
		if (!s) return null;
		// 取前10位日期部分
		const ds = s.length >= 10 ? s.substring(0, 10) : s;
		const d = new Date(ds + 'T00:00:00');
		if (isNaN(d.getTime())) return null;
		return d;
	};

	// 每个刻度单元包含的天数
	const daysPerUnit = computed(() => {
		if (scaleMode.value === 'day') return 1;
		if (scaleMode.value === 'week') return 7;
		if (scaleMode.value === 'month') return 30; // 仅用于范围估算，实际按月对齐
		return Math.max(1, Math.floor(customDays.value));
	});

	// 计算时间轴范围（按刻度对齐到刻度边界）
	const dateRange = computed(() => {
		let min: Date | null = null;
		let max: Date | null = null;
		rawTasks.value.forEach(t => {
			const s = parseDate(t.startdate);
			const e = parseDate(t.enddate);
			if (s) {
				if (!min || s < min) min = s;
				if (!max || s > max) max = s;
			}
			if (e) {
				if (!min || e < min) min = e;
				if (!max || e > max) max = e;
			}
		});
		if (!min || !max) {
			const now = new Date();
			min = new Date(now.getFullYear(), now.getMonth(), 1);
			max = new Date(now.getFullYear(), now.getMonth() + 1, 0);
		}
		let start = new Date(min);
		let end = new Date(max);
		if (scaleMode.value === 'week') {
			// 对齐到周一（getDay: 0=周日, 1=周一）
			const wd = start.getDay();
			const diff = wd === 0 ? 6 : wd - 1;
			start.setDate(start.getDate() - diff);
			// end 对齐到周日
			const wd2 = end.getDay();
			const diff2 = wd2 === 0 ? 0 : 7 - wd2;
			end.setDate(end.getDate() + diff2);
		} else if (scaleMode.value === 'month') {
			// 对齐到月初/月末
			start = new Date(start.getFullYear(), start.getMonth(), 1);
			end = new Date(end.getFullYear(), end.getMonth() + 1, 0);
		} else if (scaleMode.value === 'custom') {
			// 前后留一个单元
			start.setDate(start.getDate() - daysPerUnit.value);
			end.setDate(end.getDate() + daysPerUnit.value);
		} else {
			// day 模式前后留 2 天
			start.setDate(start.getDate() - 2);
			end.setDate(end.getDate() + 2);
		}
		return { start, end };
	});

	// 日期表头（按刻度生成单元）
	const dateHeaders = computed(() => {
		const { start, end } = dateRange.value;
		const arr: any[] = [];
		let cur = new Date(start);
		let lastGroupKey = '';
		while (cur <= end) {
			const unitStart = new Date(cur);
			let unitEnd = new Date(cur);
			let groupLabel = '';
			let unitLabel = '';
			let showGroup = false;

			if (scaleMode.value === 'day') {
				unitEnd = new Date(cur);
				const y = cur.getFullYear();
				const m = cur.getMonth();
				const groupKey = `${y}-${m}`;
				if (groupKey !== lastGroupKey) {
					showGroup = true;
					groupLabel = `${y}年${m + 1}月`;
				}
				unitLabel = String(cur.getDate());
				lastGroupKey = groupKey;
				cur.setDate(cur.getDate() + 1);
			} else if (scaleMode.value === 'week') {
				// unitStart 为周一，unitEnd 为周日
				unitEnd = new Date(unitStart);
				unitEnd.setDate(unitEnd.getDate() + 6);
				const y = unitStart.getFullYear();
				const m = unitStart.getMonth();
				const groupKey = `${y}-${m}`;
				if (groupKey !== lastGroupKey) {
					showGroup = true;
					groupLabel = `${y}年${m + 1}月`;
				}
				unitLabel = `${unitStart.getMonth() + 1}/${unitStart.getDate()}`;
				lastGroupKey = groupKey;
				cur.setDate(cur.getDate() + 7);
			} else if (scaleMode.value === 'month') {
				unitEnd = new Date(unitStart.getFullYear(), unitStart.getMonth() + 1, 0);
				const y = unitStart.getFullYear();
				const groupKey = `${y}`;
				if (groupKey !== lastGroupKey) {
					showGroup = true;
					groupLabel = `${y}年`;
				}
				unitLabel = `${unitStart.getMonth() + 1}月`;
				lastGroupKey = groupKey;
				cur = new Date(cur.getFullYear(), cur.getMonth() + 1, 1);
			} else {
				// custom
				unitEnd = new Date(unitStart);
				unitEnd.setDate(unitEnd.getDate() + daysPerUnit.value - 1);
				const y = unitStart.getFullYear();
				const m = unitStart.getMonth();
				const groupKey = `${y}-${m}`;
				if (groupKey !== lastGroupKey) {
					showGroup = true;
					groupLabel = `${y}年${m + 1}月`;
				}
				unitLabel = `${unitStart.getMonth() + 1}/${unitStart.getDate()}-${unitEnd.getMonth() + 1}/${unitEnd.getDate()}`;
				lastGroupKey = groupKey;
				cur.setDate(cur.getDate() + daysPerUnit.value);
			}

			// 判断该单元是否含周末/今天
			const containsWeekend = checkContainsWeekend(unitStart, unitEnd);
			const containsToday = checkContainsDate(unitStart, unitEnd, todayStr.value);
			arr.push({
				unitStart,
				unitEnd,
				groupLabel,
				unitLabel,
				showGroup,
				isWeekend: containsWeekend && scaleMode.value === 'day',
				isToday: containsToday
			});
		}
		return arr;
	});

	// 判断日期区间是否包含周末
	const checkContainsWeekend = (start: Date, end: Date): boolean => {
		const cur = new Date(start);
		while (cur <= end) {
			const wd = cur.getDay();
			if (wd === 0 || wd === 6) return true;
			cur.setDate(cur.getDate() + 1);
		}
		return false;
	};
	// 判断日期区间是否包含指定日期(YYYY-MM-DD)
	const checkContainsDate = (start: Date, end: Date, dateStr: string): boolean => {
		const target = parseDate(dateStr);
		if (!target) return false;
		return target >= start && target <= end;
	};

	const totalUnits = computed(() => dateHeaders.value.length);
	const totalWidth = computed(() => totalUnits.value * dayWidth.value);

	// 日期转所在刻度单元的索引
	const dateToUnitIndex = (d: Date): number => {
		return dateHeaders.value.findIndex(u => d >= u.unitStart && d <= u.unitEnd);
	};

	const hasValidDate = (item: any) => {
		return parseDate(item.startdate) && parseDate(item.enddate);
	};

	// 状态判断
	// 0未启动 1进行中 2关闭 3待审核 4完成
	const getBarClass = (item: any) => {
		if (!item) return 'bar-pending';
		// 子环节逾期时，父节点（任务行）同样按逾期着色提示
		// （任务自身可能未到期，但其下环节已逾期）
		if (item.hasOverdue) return 'bar-overdue-running';
		const status = Number(item.status);
		const today = todayStr.value;
		const enddate = item.enddate ? item.enddate.substring(0, 10) : '';
		if (status === 0) return 'bar-pending'; // 灰色 未启动
		if (status === 1) {
			// 进行中
			if (enddate && enddate < today) return 'bar-overdue-running'; // 逾期进行中 淡红
			return 'bar-running'; // 进行中 蓝色
		}
		if (status === 3) {
			// 待审核
			if (enddate && enddate < today) return 'bar-overdue-review'; // 逾期待审核 红
			return 'bar-review'; // 正常待审核 橙
		}
		if (status === 4) return 'bar-done'; // 绿色 完成
		return 'bar-pending';
	};

	const getBarStyle = (item: any) => {
		if (!item) return {};
		const s = parseDate(item.startdate);
		const e = parseDate(item.enddate);
		if (!s || !e) return {};
		let startIdx = dateToUnitIndex(s);
		let endIdx = dateToUnitIndex(e);
		if (startIdx < 0) startIdx = 0;
		if (endIdx < 0) endIdx = startIdx;
		if (endIdx < startIdx) endIdx = startIdx;
		const left = startIdx * (dayWidth.value+1);
		const width = (endIdx - startIdx + 1) * (dayWidth.value+1);
		console.log(left , width)
		return { left: left + 'px', width: width + 'px' };
	};

	// 任务是否已汇报
	const isReported = (item: any): boolean => {
		return String(item && item.reportflag) === '1';
	};

	// 完成进度：
	// - 未填写/为空/非数字时按 0 处理（字段为 int DEFAULT 0，未填写即 0）
	// - 状态为"已完成"(status=4) 且未填写或为 0 时，默认按 100% 显示
	const finishPercentOf = (item: any): number => {
		const raw = item ? item.finishpercent : undefined;
		const p = Number(raw);
		const filled = raw !== undefined && raw !== null && raw !== '' && !isNaN(p) && p > 0;
		if (!filled) {
			if (item && Number(item.status) === 4) return 100;
			return 0;
		}
		if (p > 100) return 100;
		return p;
	};
	const getBarTitle = (item: any) => {
		const statusMap: any = { 0: '未启动', 1: '进行中', 2: '关闭', 3: '待审核', 4: '完成' };
		// 汇报状态：已汇报时附带汇报时间
		const reportTxt = isReported(item) ? `已汇报(${item.reporttime || '-'})` : '未汇报';
		return `${item.tasktitle} | 执行人:${item.operatorname || '-'} | 审核人:${item.checkname || '-'} | 状态:${statusMap[item.status] || ''} | 汇报:${reportTxt} | 进度:${finishPercentOf(item)}% | 开始:${item.startdate || '-'} | 结束:${item.enddate || '-'}`;
	};

	// ========== 父子结构处理 ==========
	// rawTasks 已按 startdate 升序。构建父子树并展平（带层级、折叠状态）。
	const collapsedSet = ref<Set<number>>(new Set());
	// 顶部：隐藏已完成任务
	const hideDoneTasks = ref<boolean>(false);
	// 顶部：隐藏已汇报任务（reportflag==='1'）
	const hideReportedTasks = ref<boolean>(false);
	// 单任务手动隐藏
	const hiddenTaskIds = ref<Set<number>>(new Set());

	const flatTasks = computed(() => {
	// 1. 为每行生成"唯一且稳定"的 key：id 有效且不重复时用 id，否则用其在 rawTasks 中的下标。
	//    key 重复或不稳定会让 Vue 在列表增删时定位错锚点，抛出
	//    "insertBefore ... node is not a child of this node" 错误。
	const idCount = new Map<string, number>();
	rawTasks.value.forEach(t => {
		const k = t && t.id !== undefined && t.id !== null ? String(t.id) : '';
		idCount.set(k, (idCount.get(k) || 0) + 1);
	});
	const keyMap = new Map<any, string>();
	rawTasks.value.forEach((t, i) => {
		const k = t && t.id !== undefined && t.id !== null ? String(t.id) : '';
		keyMap.set(t, (k !== '' && idCount.get(k) === 1) ? k : ('__i' + i));
	});
	// 2. 当前数据集中存在的任务 id（用于判断某任务的父任务是否也在结果集内）
	const taskIds = new Set<number>();
	rawTasks.value.forEach(t => {
		const id = Number(t.id);
		if (id) taskIds.add(id);
	});
		// 2. 构建子任务映射
		const childrenMap = new Map<number, any[]>();
		const topTasks: any[] = [];
		rawTasks.value.forEach(t => {
			const pid = Number(t.taskpid);
			const selfId = Number(t.id);
			// 父任务不在当前结果集中（如跨项目查询、父任务被查询条件过滤掉）或自引用时，
			// 该任务找不到可挂载的父节点，需视为顶级任务，否则会因无法从顶级节点遍历到而整条不渲染
			if (pid && pid > 0 && pid !== selfId && taskIds.has(pid)) {
				if (!childrenMap.has(pid)) childrenMap.set(pid, []);
				childrenMap.get(pid)!.push(t);
			} else {
				topTasks.push(t);
			}
		});
		// 3. 展平，处理层级和折叠
		// 判断任务是否应被"过滤"（不渲染行且不渲染子任务树）
		const isFiltered = (task: any): boolean => {
			const id = Number(task.id);
			// 单任务手动隐藏
			if (hiddenTaskIds.value.has(id)) return true;
			// 全局隐藏已完成任务（status===4）
			if (hideDoneTasks.value && Number(task.status) === 4) return true;
			// 全局隐藏已汇报任务（reportflag==='1'）
			if (hideReportedTasks.value && String(task.reportflag) === '1') return true;
			return false;
		};
		const result: any[] = [];
		// 防御：数据异常形成父子环时避免无限递归
		const visited = new Set<number>();
		const walk = (task: any, level: number) => {
			// 空数据防护：避免对 null/undefined 取属性或展开时报错
			if (!task) return;
			const tid = Number(task.id);
			if (tid && visited.has(tid)) return;
			if (tid) visited.add(tid);
			// 被过滤的任务：不加入结果，也不递归子任务
			if (isFiltered(task)) return;
			const isParent = childrenMap.has(Number(task.id));
			const collapsed = collapsedSet.value.has(Number(task.id));
			result.push({
				...task,
				__key: keyMap.get(task) || ('__x' + result.length),
				__level: level,
				__isParent: isParent,
				__collapsed: collapsed,
				__hidden: false
			});
			const children = childrenMap.get(Number(task.id));
			if (isParent && !collapsed && Array.isArray(children)) {
				children.forEach(child => walk(child, level + 1));
			}
		};
		topTasks.forEach(t => walk(t, 0));
		// 4. 设置 __hidden：若祖先被折叠则隐藏
		const markVisible = (task: any, level: number, ancestorCollapsed: boolean) => {
			if (!task) return;
			const id = Number(task.id);
			// 被过滤的任务不参与（已在 walk 中跳过）
			if (!result.find(r => Number(r.id) === id)) return;
			const isParent = childrenMap.has(id);
			const collapsed = collapsedSet.value.has(id);
			const hidden = ancestorCollapsed;
			const r = result.find(r => Number(r.id) === id);
			if (r) r.__hidden = hidden;
			const children = childrenMap.get(id);
			if (isParent && Array.isArray(children)) {
				children.forEach(child => markVisible(child, level + 1, hidden || collapsed));
			}
			};
		topTasks.forEach(t => markVisible(t, 0, false));
		return result;
	});

	const toggleCollapse = (item: any) => {
		const id = Number(item.id);
		if (collapsedSet.value.has(id)) {
			collapsedSet.value.delete(id);
		} else {
			collapsedSet.value.add(id);
		}
		// 触发响应式更新
		collapsedSet.value = new Set(collapsedSet.value);
	};

	const expandAll = () => {
		collapsedSet.value = new Set();
	};
	const collapseAll = () => {
		const s = new Set<number>();
		flatTasks.value.forEach(t => {
			if (t.__isParent) s.add(Number(t.id));
		});
		collapsedSet.value = s;
	};

	// 隐藏单个任务
	const hideSingleTask = (item: any) => {
		const id = Number(item.id);
		hiddenTaskIds.value.add(id);
		hiddenTaskIds.value = new Set(hiddenTaskIds.value);
	};
	// 显示全部任务（清除单任务隐藏）
	const showAllTasks = () => {
		hiddenTaskIds.value = new Set();
	};

	// 点击任务
	const onTaskClick = (item: any) => {
		emit('opentask', item);
	};

	// 加载数据
	const loadData = () => {
		if (!alive) return;
		// 外部传入任务数组时，直接使用，不再请求后端
		if (externalTasks.value) {
			rawTasks.value = externalTasks.value;
			loading.value = false;
			return;
		}
		loading.value = true;
		requestTaskGanttList({
			projectid: props.projectid
		}).then((res: any) => {
			if (!alive) return;
			loading.value = false;
			// 后端 TaskGanttList 直接返回数组 [{...}, ...]
			// 统一过滤 null/undefined 项，保证后续构建树时不会因空对象报错
			let arr: any[] = [];
			if (Array.isArray(res)) {
				arr = res;
			} else if (res && Array.isArray(res.datalist)) {
				arr = res.datalist;
			} else if (res && Array.isArray(res.data)) {
				arr = res.data;
			}
			rawTasks.value = arr.filter((t: any) => t != null);
		}).catch(() => {
			if (!alive) return;
			loading.value = false;
		});
	};

	// 滚动到今天所在刻度
	const scrollToToday = () => {
		if (ganttRightRef.value) {
			const todayIdx = dateHeaders.value.findIndex(d => d.isToday);
			if (todayIdx >= 0) {
				ganttRightRef.value.scrollLeft = Math.max(0, todayIdx * dayWidth.value - 200);
			}
		}
	};

	onMounted(() => {
		// 外部传入任务数组时，不再加载项目信息
		if (!externalTasks.value && props.projectid) {
			xmDetails2({ id: props.projectid }).then((res: any) => {
				if (!alive) return;
				if (res.status === 1 && res.datalist && res.datalist.length > 0) {
					projectInfo.value = res.datalist[0];
				}
			});
		}
		loadData();
		// 滚动到今天位置
		nextTick(() => {
			scrollToToday();
		});
	});

	expose({ loadData });

return (_ctx: any,_cache: any) => {
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_ArrowRight = _resolveComponent("ArrowRight")!
  const _component_ArrowDown = _resolveComponent("ArrowDown")!
  const _component_Hide = _resolveComponent("Hide")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (projectInfo.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(projectInfo.value.code) + " - " + _toDisplayString(projectInfo.value.projectname), 1))
        : _createCommentVNode("", true),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createVNode(_component_el_radio_group, {
          modelValue: scaleMode.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((scaleMode).value = $event)),
          size: "small",
          onChange: onScaleChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_radio_button, { label: "day" }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "week" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "month" }, {
              default: _withCtx(() => [
                _hoisted_9
              ]),
              _: 1
            }),
            _createVNode(_component_el_radio_button, { label: "custom" }, {
              default: _withCtx(() => [
                _hoisted_10
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"]),
        (scaleMode.value === 'custom')
          ? (_openBlock(), _createBlock(_component_el_input_number, {
              key: 0,
              modelValue: customDays.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((customDays).value = $event)),
              min: 2,
              max: 90,
              step: 1,
              size: "small",
              style: {"margin-left":"8px","width":"120px"},
              onChange: onScaleChange
            }, null, 8, ["modelValue"]))
          : _createCommentVNode("", true),
        (scaleMode.value === 'custom')
          ? (_openBlock(), _createElementBlock("span", _hoisted_11, "天/列"))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createVNode(_component_el_button, {
          size: "small",
          type: hideDoneTasks.value ? 'info' : 'default',
          onClick: _cache[2] || (_cache[2] = ($event: any) => (hideDoneTasks.value = !hideDoneTasks.value))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(hideDoneTasks.value ? '显示已完成任务' : '隐藏已完成任务'), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          size: "small",
          type: hideReportedTasks.value ? 'info' : 'default',
          onClick: _cache[3] || (_cache[3] = ($event: any) => (hideReportedTasks.value = !hideReportedTasks.value))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(hideReportedTasks.value ? '显示已汇报任务' : '隐藏已汇报任务'), 1)
          ]),
          _: 1
        }, 8, ["type"]),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: showAllTasks,
          disabled: hiddenTaskIds.value.size === 0
        }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }, 8, ["disabled"]),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: expandAll
        }, {
          default: _withCtx(() => [
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          size: "small",
          onClick: collapseAll
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createVNode(_component_el_icon, { class: "is-loading" }, {
              default: _withCtx(() => [
                _createVNode(_unref(Loading))
              ]),
              _: 1
            }),
            _hoisted_18
          ]))
        : _createCommentVNode("", true),
      (_unref(flatTasks).length === 0 && !loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, "暂无任务数据"))
        : _createCommentVNode("", true),
      (_unref(flatTasks).length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
            _createElementVNode("div", {
              class: "gantt-left",
              style: _normalizeStyle({ width: __props.showFinishTime ? '436px' : '360px' })
            }, [
              _createElementVNode("div", _hoisted_21, [
                _hoisted_22,
                _hoisted_23,
                _hoisted_24,
                (__props.showFinishTime)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, "完成时间"))
                  : _createCommentVNode("", true)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatTasks), (item, idx) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 'left-'+item.__key,
                  class: _normalizeClass(["gantt-row", { 'is-parent': item.__isParent, 'is-child': item.__level > 0, 'is-collapsed-hidden': item.__hidden }]),
                  onClick: ($event: any) => (onTaskClick(item))
                }, [
                  _createElementVNode("div", {
                    class: "gantt-title-cell",
                    style: _normalizeStyle({ paddingLeft: (12 + item.__level * 20) + 'px' })
                  }, [
                    _withDirectives(_createElementVNode("span", {
                      class: "toggle-icon",
                      onClick: _withModifiers(($event: any) => (toggleCollapse(item)), ["stop"])
                    }, [
                      _withDirectives(_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowRight)
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, item.__collapsed]
                      ]),
                      _withDirectives(_createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ArrowDown)
                        ]),
                        _: 2
                      }, 1536), [
                        [_vShow, !item.__collapsed]
                      ])
                    ], 8, _hoisted_27), [
                      [_vShow, item.__isParent]
                    ]),
                    _withDirectives(_createElementVNode("span", _hoisted_28, null, 512), [
                      [_vShow, !item.__isParent]
                    ]),
                    _createElementVNode("span", {
                      class: "eye-icon",
                      title: "隐藏该任务",
                      onClick: _withModifiers(($event: any) => (hideSingleTask(item)), ["stop"])
                    }, [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Hide)
                        ]),
                        _: 1
                      })
                    ], 8, _hoisted_29),
                    _createElementVNode("span", {
                      class: "task-title-text",
                      title: item.tasktitle
                    }, _toDisplayString(item.tasktitle), 9, _hoisted_30),
                    (isReported(item))
                      ? (_openBlock(), _createElementBlock("span", {
                          key: 0,
                          class: "reported-badge",
                          title: '已汇报：' + (item.reporttime || '-')
                        }, "报", 8, _hoisted_31))
                      : _createCommentVNode("", true),
                    (item.hasOverdue)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_32, "逾期"))
                      : _createCommentVNode("", true)
                  ], 4),
                  _createElementVNode("div", {
                    class: "gantt-info-cell",
                    title: item.operatorname
                  }, _toDisplayString(item.operatorname || '-'), 9, _hoisted_33),
                  _createElementVNode("div", {
                    class: "gantt-info-cell",
                    title: item.checkname
                  }, _toDisplayString(item.checkname || '-'), 9, _hoisted_34),
                  (__props.showFinishTime)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "gantt-info-cell gantt-info-cell-time",
                        title: item.finishtime || '未设置'
                      }, _toDisplayString(item.finishtime || '-'), 9, _hoisted_35))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_26)), [
                  [_vShow, !item.__hidden]
                ])
              }), 128))
            ], 4),
            _createElementVNode("div", {
              class: "gantt-right",
              ref_key: "ganttRightRef",
              ref: ganttRightRef
            }, [
              _createElementVNode("div", _hoisted_36, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dateHeaders), (d, di) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: di,
                    class: _normalizeClass(["date-cell", { 'is-weekend': d.isWeekend, 'is-today': d.isToday }]),
                    style: _normalizeStyle({ width: dayWidth.value + 'px' })
                  }, [
                    (d.showGroup)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, _toDisplayString(d.groupLabel), 1))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, _toDisplayString(d.unitLabel), 1)
                  ], 6))
                }), 128))
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(flatTasks), (item, idx) => {
                return _withDirectives((_openBlock(), _createElementBlock("div", {
                  key: 'bar-'+item.__key,
                  class: "gantt-row gantt-bar-row",
                  onClick: ($event: any) => (onTaskClick(item))
                }, [
                  _createElementVNode("div", {
                    class: "bar-track",
                    style: _normalizeStyle({ width: _unref(totalWidth) + 'px' })
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dateHeaders), (d, di) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: 'bg-' + di,
                        class: _normalizeClass(["bar-bg-cell", { 'is-weekend': d.isWeekend, 'is-today': d.isToday }]),
                        style: _normalizeStyle({ width: dayWidth.value + 'px' })
                      }, null, 6))
                    }), 128)),
                    _withDirectives(_createElementVNode("div", {
                      class: _normalizeClass(["task-bar", getBarClass(item)]),
                      style: _normalizeStyle(getBarStyle(item)),
                      title: getBarTitle(item)
                    }, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(finishPercentOf(item)) + "%", 1),
                      (isReported(item))
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            class: "bar-report-flag",
                            title: '已汇报：' + (item.reporttime || '-')
                          }, "报", 8, _hoisted_42))
                        : _createCommentVNode("", true),
                      (finishPercentOf(item) > 0 && finishPercentOf(item) < 100)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            class: "task-bar-progress",
                            style: _normalizeStyle({ width: finishPercentOf(item) + '%' })
                          }, null, 4))
                        : _createCommentVNode("", true)
                    ], 14, _hoisted_40), [
                      [_vShow, hasValidDate(item)]
                    ]),
                    _withDirectives(_createElementVNode("div", {
                      class: "task-bar-no-date",
                      title: __props.noDateText
                    }, _toDisplayString(__props.noDateText), 9, _hoisted_43), [
                      [_vShow, !hasValidDate(item)]
                    ])
                  ], 4)
                ], 8, _hoisted_39)), [
                  [_vShow, !item.__hidden]
                ])
              }), 128))
            ], 512)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})